import { action, observable } from "mobx";
import { Subject } from "rxjs";
import { url } from "./APIEndPoints";
import HttpService from "./HttpService"; 
import {
  AuthService,
  buildParamString,
  IAPIResponse,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import { BeneficiaryModel } from "../models/BeneficiaryModel";
import { IAPIBeneficiaryModel } from "../interfaces/IAPIBeneficiaryModel";

export default class BeneficiaryService {
  @observable public beneficiaries: BeneficiaryModel[] = [];
  public isLoadingInProgress = true;
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );

    AuthService.hasAccount &&
      this.loadAllBeneficiaries(AuthService.authData.accountId);
  }

  @action
  loadAllBeneficiaries(accountId: string) {
    this.isLoadingInProgress = true;
    const params: string = buildParamString({
      accountId: accountId,
    });

    this.httpService
      .get<
        IAPIResponse<IAPIBeneficiaryModel[]>
      >(url.getAllBeneficiaries, params)
      .subscribe({
        next: (d) => {
          this.beneficiaries = BeneficiaryModel.deserializeAPIList(d.result);
          this.isLoadingInProgress = false;
        },
      });
  }

  @action createBeneficiary(
    accountId: string,
    name: string,
    subject: Subject<BeneficiaryModel>
  ) {
    const requestBody = {
      accountId: accountId,
      name: name,
    };

    this.httpService
      .post<
        IAPIResponse<IAPIBeneficiaryModel>
      >(url.createBeneficiary, requestBody)
      .subscribe({
        next: (d) => {
          const mappedData = BeneficiaryModel.deserializeAPIModel(d.result);

          const ifExists = this.beneficiaries.find(
            (b) => b.id === mappedData.id
          );
          if (mappedData && !ifExists) {
            this.beneficiaries.push(mappedData);
          }
          subject.next(mappedData);
        },
        error: (e) => {
          ToastService.showError("Error Occured");
          subject.error(e);
        },
      });
  }
}
